
























import Vue from "vue";
import { authService } from "@/common/services/AuthService";
import FirebaseSignIn from "@/common/components/FirebaseSignIn.vue";
import ReceiptsTable, { ReceiptTableOptions } from "@/receipts/components/ReceiptsTable.vue";
import ReceiptDialog from "@/receipts/components/ReceiptDialog.vue";
import Scaffold from "@/Scaffold.vue";
import { AdminReceipt, AdminReceiptListItem } from "@/common/models/Receipt";
import { receiptsService } from "@/common/services/ReceiptsService";

export default Vue.extend({
  name: "Receipts",
  components: {
    FirebaseSignIn,
    ReceiptsTable,
    ReceiptDialog,
    Scaffold,
  },

  data() {
    return {
      items: [] as AdminReceiptListItem[],
      totalItems: 0 as number,
      loading: true as boolean,
      loadingReceipt: false as boolean,
      receipt: null as AdminReceipt | null,
      options: {
        page: 1,
        itemsPerPage: 10,
      } as ReceiptTableOptions,
      authService: authService,
      receiptsService: receiptsService,
    };
  },
  computed: {
    breadcrumbs(): Array<Record<string, string | boolean>> {
      return [
        {
          text: "Home",
          to: "/",
        },
        {
          text: "Receipts",
          disabled: true,
        },
      ];
    },
  },
  watch: {
    options: {
      handler(): void {
        this.fetchReceipts();
      },
      deep: true,
    },
  },
  methods: {
    async fetchReceipts(): Promise<void> {
      const { page, itemsPerPage } = this.options;

      try {
        this.loading = true;
        const response = await this.receiptsService.getReceipts(
          this.options.storeId,
          this.options.userId,
          this.options.from,
          this.options.to,
          (page - 1) * itemsPerPage,
          itemsPerPage
        );
        this.items = response.items;
        this.totalItems = response.total ?? Infinity;
      } catch (error: any) {
        console.error("Failed to fetch receipts", error);
      } finally {
        this.loading = false;
      }
    },
    async fetchReceipt(receiptId: string): Promise<void> {
      try {
        this.loadingReceipt = true;
        this.receipt = await this.receiptsService.getReceipt(receiptId);
      } catch (error: any) {
        console.error("Failed to fetch receipt", error);
      } finally {
        this.loadingReceipt = false;
      }
    },
    closeReceipt(): void {
      this.receipt = null;
    },
  },
});
